import { IBookingManagementActionTypes, IBookingManagementActionCreator } from "models/IBookingManagementState";

const initialState: any = {
  data: {
    assigned_bookings_list: [],
    unassigned_bookings_list:[]
  },
};

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
  switch (type) {
    case IBookingManagementActionTypes.FETCH_EMPLOYEE_BOOKINGS_LIST_REQUEST:
      return {
        ...state,
        ...initialState,
      };
    case IBookingManagementActionTypes.FETCH_EMPLOYEE_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
